import * as fs from 'fs';
import * as path from 'path';
import { colors } from './const';

const c = colors;

const TSCONFIG_FILES = ['tsconfig.json', 'tsconfig.app.json', 'tsconfig.node.json'] as const;
const REPAIR_TSCONFIG_FILES = ['tsconfig.app.json', 'tsconfig.node.json'] as const;

/** Cursor/VS Code language-service schema accepts "5.0" only for client tsconfigs. */
const IDE_SAFE_IGNORE_DEPRECATIONS = '5.0';
const LEGACY_IGNORE_DEPRECATIONS = '6.0';

function getViteScaffoldRoot(): string {
  return path.join(__dirname, '..', '..', 'templates', 'vite-scaffold');
}

/**
 * Soft-repair: replace ignoreDeprecations "6.0" → "5.0" only.
 * Does not overwrite other compilerOptions.
 */
export function softRepairIgnoreDeprecations(projectRoot: string): string[] {
  const repaired: string[] = [];

  for (const file of REPAIR_TSCONFIG_FILES) {
    const dest = path.join(projectRoot, file);
    if (!fs.existsSync(dest)) continue;
    const raw = fs.readFileSync(dest, 'utf8');
    if (!raw.includes(`"ignoreDeprecations": "${LEGACY_IGNORE_DEPRECATIONS}"`)) continue;
    const next = raw.replace(
      new RegExp(`"ignoreDeprecations"\\s*:\\s*"${LEGACY_IGNORE_DEPRECATIONS}"`, 'g'),
      `"ignoreDeprecations": "${IDE_SAFE_IGNORE_DEPRECATIONS}"`,
    );
    if (next === raw) continue;
    fs.writeFileSync(dest, next, 'utf8');
    repaired.push(file);
  }

  if (repaired.length) {
    console.log(
      `${c.green}OK:${c.reset} Soft-repaired ignoreDeprecations → "${IDE_SAFE_IGNORE_DEPRECATIONS}" (${repaired.join(', ')})`,
    );
  }

  return repaired;
}

/** Copy Vite tsconfig templates only when destination files are absent; then soft-repair legacy 6.0. */
export function writeViteScaffoldFilesIfMissing(projectRoot: string): string[] {
  const scaffoldRoot = getViteScaffoldRoot();
  const written: string[] = [];

  for (const file of TSCONFIG_FILES) {
    const src = path.join(scaffoldRoot, file);
    const dest = path.join(projectRoot, file);
    if (!fs.existsSync(src)) continue;
    if (fs.existsSync(dest)) continue;
    fs.copyFileSync(src, dest);
    written.push(file);
  }

  if (written.length) {
    console.log(
      `${c.green}OK:${c.reset} Wrote Vite tsconfig scaffold (${written.join(', ')})`,
    );
  }

  softRepairIgnoreDeprecations(projectRoot);
  return written;
}
